import logger from '@cash-web/shared/util-logger'

import { getSupportedInternalRouteInfo, redirect, removeAccountAwareRoutingParams } from './utils'

export const getRouteInfo = (url?: string) => {
  if (url == null || url === '') {
    return undefined
  }

  url = removeAccountAwareRoutingParams(url)

  let routeInfo = redirect({ url, target: '_blank' })

  const supportedInternalRoute = getSupportedInternalRouteInfo(url)
  if (supportedInternalRoute != null) {
    routeInfo = supportedInternalRoute
  }

  if (routeInfo.type === 'unsupported') {
    logger.error(new Error(`Unsupported route: ${url}`))
  }

  return routeInfo
}
